import React from "react";
import Header from "../../Components/Header/Header";

const HomePage = () => <Header />;

export default HomePage;
